import { render } from "./FloatingSidebar.vue?vue&type=template&id=62217b2c&scoped=true&ts=true"
import script from "./FloatingSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingSidebar.vue?vue&type=style&index=0&id=62217b2c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62217b2c"],['__file',"src/modules/app/components/FloatingSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62217b2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62217b2c', __exports__)) {
    api.reload('62217b2c', __exports__)
  }
  
  module.hot.accept("./FloatingSidebar.vue?vue&type=template&id=62217b2c&scoped=true&ts=true", () => {
    api.rerender('62217b2c', render)
  })

}


export default __exports__